<template>
  <div class="rentals-list-w rentals-list">
    <div class="property-items as-grid" v-show="showFullImage == false">
      <div class="property-item dropzone" v-for="sequence, index in finalImages" v-bind:key="sequence.id_product_image" :id="sequence.id_image">
        <!-- For updates, needs to change to vue -->
        <input type="hidden" class="id_product_image" :value="sequence.id_product_image">
        <input type="hidden" class="is_mark_delete" :value="'0'">

        <a class="item-media-w" @click="zoomImage(sequence)">
          <div class="item-media ">
            <div :class="formatFullStatus(sequence)"></div>
              <v-img :src="getImage(sequence)" :lazy-src="getImage(sequence)" aspect-ratio="1" contain max-height="150px" class="list-item">
                <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey" />
                </v-layout>
              </v-img>
          </div>
        </a>
        <div class="item-info">
          <div class="item-features">
            <div class="feature">{{imageName(product)}}</div>
          </div>
          <h3 class="item-title">
            <a>{{sequence.sequence}}</a>
            <div class="trash" :class="{'markDeleted' : sequence.is_marked_delete && sequence.is_marked_delete == 1}" @click="markDelete(sequence)" v-if="type !== 'retouch' && type !== 'styleguide'">
              <i class="icon-trash"></i>
            </div>
            <div v-if="getDisk(sequence) != false" :class="getDiskClass(sequence)">{{getDisk(sequence)}}</div>

          </h3>
        </div>
      </div>
    </div>

    <v-carousel v-show="showFullImage == true">
      <v-carousel-item :src="selectedImagePreview" :lazy-src="selectedImagePreview" contain />
      <button class="mr-2 mb-2 btn btn-sm orange floated" type="button" @click="closeFullImage"> Close</button>
    </v-carousel>
  </div>
</template>

<script>
import DnD from '@/mixins/dragdrop.js'
import Product from '@/mixins/product.js'

export default {
  props: ['product', 'final-images', 'images', 'type'],
  mixins: [DnD, Product],
  data: function () {
    return {
      showFullImage: false,
      selectedImagePreview: ''
    }
  },
  created () {
    if (this.final_set != null && this.finalSequence != null) {
      this.mapSequencetoImage(this.finalSequence, this.images)
    }
  },
  mounted () {
    if (this.type && (this.type == 'retouch' || this.type == 'styleguide')) {
    } else {
      this.initiateDragandDrop()
    }

    this.DnD()
  },
  methods: {
    initiateEmptySet: function () {
      for (var i = 1; i < 9; i++) {
        var obj = {
          sequence: '0' + i,
          thumbpath: 'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
        }
        this.final_set.push(obj)
      }
    },
    getDisk: function (image) {
      if (this.type != 'retouch' && image.id_image !== null && image.disk_full == null) { return 'Upload Failed' }

      return ''
    },
    getDiskClass: function (image) {
      if (this.type != 'retouch' && image.id_image !== null && image.disk_full == null) { return 'badge badge-danger disk' }
      return ''
    },
    getImage: function (image) {
      if (
        image &&
        image.retouch_location != null &&
        this.type &&
        this.type == 'retouch'
      ) {
        if(!image.is_required) {
          return 'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
        }
        return image.host_retouch + image.retouch_location
          
      } else if (image && image.raw_thumb_location != null) {
        return image.host + image.raw_thumb_location
      } else {
        return 'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      }
    },
    zoomImage: function (image) {
      var self = this
      var context = {
        content: image,
        contentType: 'image',
        show: true,
        type: this.type
      }
      this.$store.dispatch('updateModal', context)
    },
    formatImage: function (image) {
      if (image) {
        'background-image: url(' + image.host + image.raw_thumb_location + ');'
      } else {
        ('background-image: url(https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png);')
      }
    },
    formatQCStatus: function (sequence) {
      if (this.type && this.type == 'retouch') {
        if (sequence.is_retouch_approve == null) return ''
        return sequence.is_retouch_approve == 1 ? 'qc-1' : 'qc-0'
      } else {
        if (sequence.is_pretouch_approve == null) return ''
        return sequence.is_pretouch_approve == 1 ? 'qc-1' : 'qc-0'
      }
    },
    formatFullStatus: function (sequence) {
      if (sequence.id_image !== null && sequence.disk_full == null) { return 'overlay fa fa-exclamation-triangle red' }
    },
    openFullImage: function (sequence) {
      var self = this

      var selectedImage = this.selectedImage
      if (
        sequence &&
        sequence.retouch_location != null &&
        this.type &&
        this.type == 'retouch'
      ) {
        self.selectedImagePreview =
          sequence.host_retouch + sequence.retouch_location
      } else {
        self.selectedImagePreview =
          'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      }

      if (sequence && sequence.raw_thumb_location != null) {
        self.selectedImagePreview = sequence.host + sequence.raw_thumb_location
      } else {
        self.selectedImagePreview =
          'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      }

      this.showFullImage = true
    },
    closeFullImage: function () {
      this.showFullImage = false
    },
    markDelete (image) {
      this.$emit('deleteInterface', image)
    },
    initiateDragandDrop () {
      var self = this
      $('.property-items').sortable({
        tolerance: 'pointer',
        start: function (event, ui) {
          ui.placeholder.html("<div class='property-item'>Hello</div>")
        },
        update: function (event, ui) {
          self.$store.dispatch('updateimagesUpdateRequired', true)
          self.$store.dispatch(
            'updateSequenceUpdateSet',
            $('.property-items').sortable('toArray')
          )
        },
        stop: function (event, ui) {
          ui.placeholder.html('')
        }
      })
    }
  },
  computed: {
    productDetails () {
      if (this.product && this.product.item_parent_identifier) {
        return this.product
      } else if (this.product && this.product.product.base_product_id) {
        return this.product.product
      } else if (this.product && this.product.product.Item_Parent) {
        return this.product.product
      } else {
        return 'No Product'
      }
    }
  },
  watch: {
    finalImages () {
      if (this.type !== 'styleguide') {
        this.initiateDragandDrop()
      }
    },
    selectedImagePreview () {}
  }
}
</script>

<style>
.list-item {
  transition: all 1s
}
.overlay {
  position: absolute;
  right: 0;
  padding: 5px;
}
.disk {
  text-transform: uppercase;
  margin-top: 9px;
  float: right;
}

.trash {
  margin-left: 5px;
  float: right;
  font-size: 18px;
  margin-top: 8px;
  cursor: pointer;
}

.markDeleted {
  color: #da6262;
}
.property-item:hover {
  -webkit-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 2;
  -webkit-box-shadow: 0 2px 30px 0 rgba(54, 88, 206, 0.2);
  box-shadow: 0 2px 30px 0 rgba(54, 88, 206, 0.2);
  /* box-shadow: inset 0px 5px 0px #047bf8; */
}

.floated {
  margin: 10px;
  position: absolute;
  top: 0;
  right: 0;
}
.item-image {
  max-height: 150px;
  height: 150px;
}
.item-media-w .item-media:before {
  content: "";
  width: 10px;
  height: 10px;
  position: absolute;
  top: 2px;
  right: 2px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 0px 3px #fff;
  box-shadow: 0px 0px 0px 3px #fff;
}

.item-media-w .qc-1:before {
  background-color: #24b314;
}

.red {
  color: #c21a1a;
  font-size: 20px;
}

.v-image {
  z-index: 0;
}
.v-image__image,
.v-image__placeholder {
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.v-image__image {
  background-repeat: no-repeat;
}
.v-image__image--preload {
  -webkit-filter: blur(2px);
  filter: blur(2px);
}
.v-image__image--contain {
  background-size: contain;
}
.v-image__image--cover {
  background-size: cover;
}

.v-responsive {
  position: relative;
  overflow: hidden;
  flex: 1 0 auto;
  display: flex;
}
.v-responsive__content {
  flex: 1 0 0px;
}
.v-responsive__sizer {
  transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
  flex: 0 0 0px;
}

.v-progress-circular {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.v-progress-circular svg {
  width: 100%;
  height: 100%;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
}
.v-progress-circular--indeterminate svg {
  -webkit-animation: progress-circular-rotate 1.4s linear infinite;
  animation: progress-circular-rotate 1.4s linear infinite;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  transition: all 0.2s ease-in-out;
}
.v-progress-circular--indeterminate .v-progress-circular__overlay {
  -webkit-animation: progress-circular-dash 1.4s ease-in-out infinite;
  animation: progress-circular-dash 1.4s ease-in-out infinite;
  stroke-linecap: round;
  stroke-dasharray: 80, 200;
  stroke-dashoffset: 0px;
}
.v-progress-circular__underlay {
  stroke: rgba(0, 0, 0, 0.1);
  z-index: 1;
}
.v-progress-circular__overlay {
  stroke: currentColor;
  z-index: 2;
  transition: all 0.6s ease-in-out;
}
.v-progress-circular__info {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
@-webkit-keyframes progress-circular-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0px;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -125px;
  }
}
@keyframes progress-circular-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0px;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -125px;
  }
}
@-webkit-keyframes progress-circular-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes progress-circular-rotate {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
